var autoLoadDuration = 4;
var eventList = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend"];
var autoLoadTimeout = setTimeout(runScripts, autoLoadDuration * 1000);
eventList.forEach(function(event) {
    window.addEventListener(event, triggerScripts, { passive: true })
});
function triggerScripts() { 
    runScripts();
    clearTimeout(autoLoadTimeout);
    eventList.forEach(function(event) {
         window.removeEventListener(event, triggerScripts, { passive: true });
    });
} 
/* lj 15.10: scripturile amanate se executa in ordinea din pagina (async=false). Inainte, pe conexiuni lente main.min.js
   rula inaintea theme-vendors.min.js si dadea "$(...).appear / magnificPopup is not a function". */
var ljScriptsRan = false;
function runScripts() {
    if (ljScriptsRan) return; ljScriptsRan = true;
    document.querySelectorAll("script[delay]").forEach(function(old) {
        var s = document.createElement("script");
        s.src = old.getAttribute("delay"); s.async = false;
        old.parentNode.replaceChild(s, old);
    });
}